"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class QueryPolicyApi extends runtime.BaseAPI {
    /**
     * Clone an existing QueryPolicyCollection to the new Parent Resource
     * Clone QueryPolicyCollection
     */
    queryPolicyServiceCloneQueryPolicyCollectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling queryPolicyServiceCloneQueryPolicyCollection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querypolicy.v1.CloneQueryPolicyCollectionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-policy-service/queryPolicyCollections/{luid}/clone`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerypolicyV1CloneQueryPolicyCollectionRequestToJSON(requestParameters.tableauQuerypolicyV1CloneQueryPolicyCollectionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerypolicyV1CloneQueryPolicyCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Clone an existing QueryPolicyCollection to the new Parent Resource
     * Clone QueryPolicyCollection
     */
    queryPolicyServiceCloneQueryPolicyCollection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryPolicyServiceCloneQueryPolicyCollectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Creates a new QueryPolicyCollection on the logged in user\'s current site
     * Create a new QueryPolicyCollection
     */
    queryPolicyServiceCreatePolicyCollectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querypolicy.v1.CreatePolicyCollectionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-policy-service/policyCollections`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerypolicyV1CreatePolicyCollectionRequestToJSON(requestParameters.tableauQuerypolicyV1CreatePolicyCollectionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerypolicyV1CreateQueryPolicyCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Creates a new QueryPolicyCollection on the logged in user\'s current site
     * Create a new QueryPolicyCollection
     */
    queryPolicyServiceCreatePolicyCollection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryPolicyServiceCreatePolicyCollectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes a QueryPolicyCollection
     * Delete QueryPolicyCollection
     */
    queryPolicyServiceDeleteQueryPolicyCollectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling queryPolicyServiceDeleteQueryPolicyCollection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-policy-service/queryPolicyCollections/{luid}`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a QueryPolicyCollection
     * Delete QueryPolicyCollection
     */
    queryPolicyServiceDeleteQueryPolicyCollection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.queryPolicyServiceDeleteQueryPolicyCollectionRaw(requestParameters);
        });
    }
    /**
     * Retrieves a QueryPolicyCollection
     * Retrieve QueryPolicyCollection
     */
    queryPolicyServiceGetPolicyCollectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling queryPolicyServiceGetPolicyCollection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-policy-service/policyCollections/{luid}`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerypolicyV1GetQueryPolicyCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves a QueryPolicyCollection
     * Retrieve QueryPolicyCollection
     */
    queryPolicyServiceGetPolicyCollection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryPolicyServiceGetPolicyCollectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Modifies the specified attributes of a QueryPolicyCollection children
     * Modify QueryPolicyCollection children
     */
    queryPolicyServiceModifyQueryPolicyCollectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling queryPolicyServiceModifyQueryPolicyCollection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querypolicy.v1.ModifyQueryPolicyCollectionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-policy-service/queryPolicyCollections/{luid}/modify`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerypolicyV1ModifyQueryPolicyCollectionRequestToJSON(requestParameters.tableauQuerypolicyV1ModifyQueryPolicyCollectionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerypolicyV1ModifyQueryPolicyCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Modifies the specified attributes of a QueryPolicyCollection children
     * Modify QueryPolicyCollection children
     */
    queryPolicyServiceModifyQueryPolicyCollection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryPolicyServiceModifyQueryPolicyCollectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Publishes a QueryPolicyCollection
     * Publishes QueryPolicyCollection forbidding further modifications
     */
    queryPolicyServicePublishQueryPolicyCollectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling queryPolicyServicePublishQueryPolicyCollection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.querypolicy.v1.PublishQueryPolicyCollectionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/query-policy-service/queryPolicyCollections/{luid}/publish`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauQuerypolicyV1PublishQueryPolicyCollectionRequestToJSON(requestParameters.tableauQuerypolicyV1PublishQueryPolicyCollectionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauQuerypolicyV1PublishQueryPolicyCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Publishes a QueryPolicyCollection
     * Publishes QueryPolicyCollection forbidding further modifications
     */
    queryPolicyServicePublishQueryPolicyCollection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.queryPolicyServicePublishQueryPolicyCollectionRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.QueryPolicyApi = QueryPolicyApi;
